import { Modal, Button, Checkbox } from "antd";
import React from "react";

// import "./styles.css";

const CheckboxGroup = Checkbox.Group;

const ChooseColumnDialog = ({
  title,
  visible,
  handleSave,
  handleCancel,
  data,
  onCheckAllChange,
  onSingleChange,
  indeterminate,
  columnCheckAll,
  columnCheckedList,
}) => {
  return (
    <Modal
      className="modal-outlet"
      title={title}
      visible={visible}
      onOk={handleSave}
      onCancel={handleCancel}
      width={"25%"}
      centered
      footer={[
        <Button
          key="back"
          onClick={handleCancel}
          className="btn-modal btn-default"
        >
          Kembali
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSave}
          className="btn-modal"
        >
          Tambah
        </Button>,
      ]}
    >
      <Checkbox
        className="outlet-all-checkbox"
        checked={columnCheckAll}
        onChange={onCheckAllChange}
        indeterminate={indeterminate}
      >
        Tampilkan Semua Kolom
      </Checkbox>
      <CheckboxGroup
        className="outlet-group-checkbox"
        options={data}
        value={columnCheckedList}
        onChange={onSingleChange}
      />
    </Modal>
  );
};

export default ChooseColumnDialog;
